<template>
	<form-field label="Status" has-icon icon-class="fa-chevron-down">
		<select v-model="selectedStatus" aria-label="Selected Status">
			<option :value="null">{{ allStatusLabel }}</option>
			<option v-for="status in statuses" :key="status.value" :value="status.value">
				{{ status.label }}
			</option>
		</select>
	</form-field>
</template>

<script>
export default {
	props: {
		modelValue: String,
		statuses: {
			type: Array,
			default: () => [
				{ value: 'active', label: 'Active' },
				{ value: 'inactive', label: 'Inactive' },
				{ value: 'suspended', label: 'Suspended' }
			]
		},
		allStatusLabel: {
			type: String,
			default: 'All Statuses'
		}
	},
	emits: ['update:modelValue'],
	computed: {
		selectedStatus: {
			get() {
				return this.modelValue
			},
			set(value) {
				this.$emit('update:modelValue', value)
			}
		}
	}
}
</script>
